var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:down-line",
    clipPath: "url(#clip0_797_1451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3614 11.7636C16.5566 11.959 16.6664 12.2239 16.6664 12.5001C16.6664 12.7763 16.5566 13.0412 16.3614 13.2365L10.4687 19.1293C10.3726 19.2287 10.2576 19.3081 10.1305 19.3627C10.0035 19.4173 9.86676 19.446 9.72845 19.4472C9.59014 19.4484 9.45297 19.4221 9.32496 19.3697C9.19694 19.3173 9.08064 19.24 8.98283 19.1422C8.88503 19.0444 8.80768 18.9281 8.7553 18.8C8.70293 18.672 8.67657 18.5349 8.67777 18.3965C8.67898 18.2582 8.70771 18.1215 8.7623 17.9945C8.8169 17.8674 8.89625 17.7524 8.99574 17.6563L14.152 12.5001L8.99574 7.34384C8.80599 7.14738 8.701 6.88425 8.70337 6.61113C8.70575 6.33801 8.8153 6.07675 9.00843 5.88361C9.20156 5.69048 9.46283 5.58093 9.73595 5.57856C10.0091 5.57618 10.2722 5.68118 10.4687 5.87092L16.3614 11.7636Z",
    fill: "#FAFAFC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_797_1451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.ac7392a66affd1923406da55a0f780d5.svg";
export { ForwardRef as ReactComponent };